export default __webpack_public_path__ + "static/media/pulse-promo-grid.fbfc2191.png";